import React from 'react';
import classnames from 'classnames';

import Icon from '../icon/Icon';

import './Error.scss';

export enum ErrorTypes {
  error = 'error',
  warning = 'warn',
}

export interface ErrorProps {
  className?: string;
  text: string;
  type?: ErrorTypes;
}

const Error = ({ className, text, type = ErrorTypes.error }: ErrorProps) => {
  return (
    <div className={classnames('error__container', type, className)}>
      <span className="error__icon">
        <Icon name="warning-circle" />
      </span>
      <span className="error__text">{text}</span>
    </div>
  );
};

export default Error;
